module.exports = __webpack_public_path__ + "img/bg_20240814.a1041014.webp";